import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFPlainNumber } from "../../../Shared/NewForms/NFPlainNumber";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { useTranslation } from "react-i18next";

const FixedAssetDetailChief = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Category")} fieldName={"category"} required />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("PurchaseDate")} fieldName={"purchaseDate"} required />
        </Col>
        <Col sm={6}>
          <NFPlainNumber fieldName={"purchaseValue"} title={t("PurchaseValue")} required />
        </Col>
        <h6>{t("Accounting accounts")}</h6>
        <Col sm={6}>
          <NFLookupInput title={t("AccountingAccount")} fieldName={"accountingAccount"} items={EnumHelper.FixedAssetDetailTestTypeEnum()} required />
        </Col>
        <Col sm={6}>
          <NFLookupInput title={t("ExpensesAccount")} fieldName={"expensesAccount"} items={EnumHelper.FixedAssetDetailTestTypeEnum()} required />
        </Col>
        <Col sm={6}>
          <NFLookupInput title={t("DepreciationAccount")} fieldName={"depreciationAccount"} items={EnumHelper.FixedAssetDetailTestTypeEnum()} required />
        </Col>
        <h6>{t("Current Information")}</h6>
        <Col sm={6}>
          <NFLookupInput title={t("Status")} fieldName={"status"} items={EnumHelper.FixedAssetDetailTestTypeEnum()} required />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("CommissioningDate")} fieldName={"commissioningDate"} />
        </Col>
        <Col sm={6}>
          <NFPlainNumber title={t("Cost")} fieldName={"cost"} required />
        </Col>
        <Col sm={6}>
          <NFPlainNumber title={t("Depreciation")} fieldName={"depreciation"} required />
        </Col>
        <Col sm={6}>
          <NFPlainNumber title={t("OneYearDepreciation")} fieldName={"oneYearDepreciation"} required />
        </Col>
        <Col sm={6}>
          <NFPlainNumber title={t("NetValue")} fieldName={"netValue"} required />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("LastAmortizationDate")} fieldName={"lastAmortizationDate"} />
        </Col>
      </Row>
    </>
  );
};

export default FixedAssetDetailChief;
